import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import HelpIcon from '@atlaskit/icon/glyph/question-circle';
import { token } from '@atlaskit/tokens';

import { FCC } from '@/utils/types';

import { tooltipContentStyles } from './styles';
import { HelpTooltipProps } from './types';

const HelpTooltip: FCC<HelpTooltipProps> = ({ testId = '', children }) => (
  <Tooltip
    content={<span css={tooltipContentStyles}>{children}</span>}
    testId={testId}
    position="right"
  >
    <HelpIcon primaryColor={token('color.icon')} size="small" label="Help" />
  </Tooltip>
);

export default HelpTooltip;
